import Raven from 'raven-js';

export function RestaurantService($http, $q, consumerService, locationService) {
    'ngInject';
    const data = {};

    let loadingDfd = $q.defer();

    const svc = {
        status: loadingDfd.promise,
        data: data,
        clearNearbyRestaurants,
        getNearbyRestaurants,
        setRestaurantData
    };
    return svc;

    function setRestaurantData(guid, name, info, diningOptions) {
        data.guid = guid;
        data.name = name;
        data.restaurantInfo = info;
        data.restaurantInfo.frontendUrl = data.restaurantInfo.frontendUrl;
        data.diningOptions = diningOptions;
        loadingDfd.resolve();
    }

    function clearNearbyRestaurants() {
        data.restaurants = undefined;
        locationService.data.locationFailed = false;
    }

    function getNearbyRestaurants() {
        clearNearbyRestaurants();

        const lat = consumerService.data.latitude;
        const lng = consumerService.data.longitude;
        const diningOption = consumerService.data.diningOption;

        if(lat && lng && data.guid && diningOption) {
            data.restaurantsLoading = true;

            return $http.get('/locations/nearestrestaurants/' + data.guid + '?lat=' + lat + '&lon=' + lng + '&unit=mi' + '&diningOption=' + diningOption)
                .then(_onRestaurantSuccess, _onRestaurantFailure);
        }
        return $q.reject('missing some data');
    }

    function _onRestaurantFailure(response) {
        data.restaurantsLoading = false;

        Raven.captureMessage(
            'Error response from getNearbyRestaurants HTTP call to the backend', {
                level: 'info',
                tags: {
                    managementGroupGuid: data.guid,
                    managementGroupName: data.name
                },
                extra: {
                    consumerServiceData: consumerService.data,
                    errorResponse: response
                }
            }
        );
    }

    function _onRestaurantSuccess(response) {
        data.restaurantsLoading = false;

        data.restaurants = response.data;
    }
}
